import { TextSettingsHelper } from '../text/settings'

export const ERROR_MODES = {
  MODAL: 'MODAL',
}

export class ErrorSettingsHelper extends TextSettingsHelper {
  _modal

  constructor(settings, modal) {
    super(settings)

    this._modal = modal
  }

  raise(callback) {
    switch (this._settings.mode) {
      case ERROR_MODES.MODAL:
        this._modal(this._settings.title, this._settings.description)

        return typeof callback === 'function' && callback()

      default:
    }
  }
}
